export default "/kiban/_next/static/images/blue-9fb32017b50781d9726b6bd75540dd59.png";